import React, { useContext, useEffect } from "react";
import "./projects.css";

import { VscGithubAlt } from "react-icons/vsc";
import { FiExternalLink } from "react-icons/fi";

import learnandearn from "../../images/learn_and_earn.jpg";
import rollDice from "../../images/dice_game.jpg";
import cleverInteriors from "../../images/clever_interiors.jpg";
import aapkiThali from "../../images/aapki_thali.jpg";
import airbnb from "../../images/airbnb.jpg";
import talktome from "../../images/talktome.jpg";
import photoeditor from "../../images/photo_editor.png";
import splashiify from "../../images/splashiify.jpg";
import { ModeContext } from "../utils/modes-context";

const slide_info = [
  {
    title: "Splashiify",
    img: splashiify,
    des: "A search engine to find HD quality Images and download them directly to your system.",
    btn1_link: "https://github.com/Krishna698-web/unsplashclone",
    btn2_link: "https://splashiify.netlify.app/",
    languages: ["React", "Tailwind CSS", "JavaScript", "Unsplash API"],
    id: Math.random().toString(),
  },
  {
    title: "Learn and Earn",
    img: learnandearn,
    des: "A place to find the right Education and get hired or work on different projects to earn. Was built as final year project.",
    btn1_link: "https://github.com/Krishna698-web/learnandearn",
    btn2_link: "https://learn-and-earn.netlify.app",
    languages: ["HTML", "CSS", "JavaScript", "Firebase"],
    id: Math.random().toString(),
  },
  {
    title: "Airbnb Clone",
    img: airbnb,
    des: "A replica of Airbnb that has key features such as user authentication, property listings, and booking functionality",
    btn1_link: "https://github.com/Krishna698-web/airbnb-clone",
    languages: ["MERN", "HTML", "Tailwind CSS", "JavaScript"],
    btn2_link: "https://aribnbclone.netlify.app/",
    id: Math.random().toString(),
  },
  {
    title: "Talk to me",
    img: talktome,
    des: "A real-time chat app using the MERN stack, which supports both one-on-one and group chats",
    btn1_link: "https://github.com/Krishna698-web/talktome",
    languages: ["MERN", "HTML", "CSS", "JavaScript", "Chakar UI"],
    btn2_link: "https://talk-tome.netlify.app/",
    id: Math.random().toString(),
  },
  {
    title: "Photo editz",
    img: photoeditor,
    des: "A simple photo editor, where you can adjust the filters and download edited image locally.",
    btn1_link: "https://github.com/Krishna698-web/photoeditor",
    languages: ["HTML", "CSS", "JavaScript"],
    btn2_link: "https://photoeditz.netlify.app/",
    id: Math.random().toString(),
  },
  {
    title: "Aapki Thali",
    img: aapkiThali,
    des: "A food ordering webapp that allows user to add meals to cart and then can also alter the cart too..",
    btn1_link: "https://github.com/Krishna698-web/aapki-thali",
    languages: ["React", "HTML", "CSS", "JavaScript"],
    btn2_link: "https://krishna698-web.github.io/aapki-thali/",
    id: Math.random().toString(),
  },
  {
    title: "Dice roll",
    img: rollDice,
    des: "A two player game, that allows one player to roll the dice while the other waits for his turn.",
    btn1_link: "https://github.com/Krishna698-web/dice-roll",
    btn2_link: "https://krishna698-web.github.io/dice-roll/",
    languages: ["HTML", "CSS", "JavaScript"],
    id: Math.random().toString(),
  },
  {
    title: "Clever Interiors",
    img: cleverInteriors,
    des: "A Simple user interface of a furniture website that has a cool looking scrolling effect made using CSS.",
    btn1_link: "https://github.com/Krishna698-web/cleverinteriors",
    btn2_link: "https://cleverinteriors.netlify.app",
    languages: ["HTML", "CSS"],
    id: Math.random().toString(),
  },
];

const Projects = () => {
  useEffect(() => {
    const oberser = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });
    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => oberser.observe(el));
  }, []);

  const { darkMode } = useContext(ModeContext);

  return (
    <section
      className={darkMode ? "projects" : "projects projects_lightmode"}
      id="projects">
      <h1 className="sub_heading">
        Projects <span></span>
      </h1>
      <div className="slides">
        {slide_info.map((item) => (
          <div key={item.id} className="slide hidden">
            <img src={item.img} alt="learn and earn" />
            <div className="projectDescription">
              <h2 className="slide_heading">{item.title}</h2>
              <p className="description">{item.des}</p>
              <div>
                {item.languages.map((language, i) => (
                  <span className="language" key={i}>
                    {language}
                  </span>
                ))}
              </div>
              <div className="buttons">
                <a
                  href={item.btn1_link}
                  target="_blank"
                  rel="noreferrer"
                  className="button">
                  <VscGithubAlt className="icon" />
                </a>
                <a
                  href={item.btn2_link}
                  target="_blank"
                  rel="noreferrer"
                  className="button">
                  <FiExternalLink className="icon" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
